// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import Metric from '../state/metric';
import {create as createHashMap} from '../../../shared/services/hashmap';

const OpenPipProgramsMetricCriteria = props => {

    const buttonText = props.metric.selectedMetrics.length > 0 ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (

        <section className='open-pips-metric-criteria'>
            <CheckboxListWithLabel
                className='open-pips-metrics'
                initialState={createHashMap(props.metric.selectedMetrics, 'key')}
                isRequired={true}
                label='METRIC'
                list={props.metric.allowedMetrics}
                onChange={props.onMetricSelect}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllPipMetrics}
                type='button'
            >
                <FormattedMessage id={buttonText}/>
            </button>

        </section>
    );

};

OpenPipProgramsMetricCriteria.displayName = 'OpenPipProgramsMetricCriteria';
OpenPipProgramsMetricCriteria.propTypes = {
    metric: PropTypes.instanceOf(Metric).isRequired,
    onMetricSelect: PropTypes.func.isRequired,
    onSelectAllPipMetrics: PropTypes.func.isRequired
};

export default OpenPipProgramsMetricCriteria;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/components/open-pip-programs-metric-criteria.js